import script from "./BankDetailsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BankDetailsInfo.vue?vue&type=script&setup=true&lang=js"

import "./BankDetailsInfo.vue?vue&type=style&index=0&id=d984f2c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d984f2c4"]])

export default __exports__